import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { useLanguage } from './LanguageContext';
interface SlideTitleProps {
  onContinue: () => void;
}
export function SlideTitle({
  onContinue
}: SlideTitleProps) {
  const {
    t
  } = useLanguage();
  return <div className="h-full w-full flex flex-col items-center justify-center px-12 py-16 text-center relative" data-id="element-873">
      <div className="z-10 max-w-4xl w-full space-y-8" data-id="element-874">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="space-y-4" data-id="element-875">
          <p className="text-sm md:text-base text-teal-400 font-semibold uppercase tracking-[0.25em]" data-id="element-876">
            {t('Snakker Investor Deck for Lind & Risør', 'Snakker Investorpræsentation for Lind & Risør')}
          </p>
          <h1 className="text-5xl md:text-7xl font-serif text-white" data-id="element-877">
            {t('Focus:', 'Fokus:')} <br data-id="element-878" />
            <span className="text-teal-400" data-id="element-879">
              {t('Healthcare Marketing Optimization', 'Optimering af Healthcare Marketing')}
            </span>
          </h1>
          <p className="text-xl md:text-2xl text-white/70 font-medium max-w-2xl mx-auto mt-6" data-id="element-880">
            {t('Unlocking significant value through continuous, scalable optimization.', 'Frigørelse af betydelig værdi gennem kontinuerlig, skalerbar optimering.')}
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.5
      }} className="pt-8" data-id="element-881">
          <Button onClick={onContinue} className="px-8 py-4 text-lg" data-id="element-882">
            {t('The Opportunity', 'Muligheden')}
          </Button>
        </motion.div>
      </div>
    </div>;
}